import { Button, Dialog, FormGroup, Icon } from "@blueprintjs/core"
import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const StyledDialog = styled(Dialog)({
  width: "450px",
  borderRadius: "6px",
  ".bp3-dialog-header": {
    background: SCIENT_COLORS.darkGray3,
    padding: "12px 16px",
    borderBottom: `1px solid ${SCIENT_COLORS.darkGray5}`,
  },
  ".bp3-dialog-body": {
    margin: "0",
    padding: "16px",
  },
  ".bp3-dialog-footer": {
    padding: "12px 16px",
    borderTop: `1px solid ${SCIENT_COLORS.darkGray5}`,
    marginTop: "8px",
  },
  ".bp3-dialog-footer-actions": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
  },
})

export const SpinnerContainer = styled(FlexContainer)({
  padding: "40px",
})

export const ErrorContainer = styled.div({
  padding: "20px",
})

export const IconWrapper = styled(Icon)({
  marginRight: "6px",
})

export const OrderDetailsContainer = styled(FormGroup)({
  background: SCIENT_COLORS.darkGray2,
  padding: "12px",
  borderRadius: "4px",
  marginBottom: "16px",
  border: `1px solid ${SCIENT_COLORS.darkGray4}`,

  ".bp3-label": {
    display: "flex",
    alignItems: "center",
    color: SCIENT_COLORS.blue4,
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "10px",

    svg: {
      color: SCIENT_COLORS.blue4,
    },
  },
})

export const OrderDetailItem = styled.div({
  display: "flex",
  alignItems: "center",
  marginBottom: "4px",
  fontSize: "14px",
  "&:last-child": {
    marginBottom: "0",
  },
})

export const OrderDetailLabel = styled.span({
  fontWeight: "bold",
  marginRight: "8px",
  color: SCIENT_COLORS.gray3,
  width: "60px",
})

export const OrderDetailValue = styled.span({
  color: SCIENT_COLORS.lightGray1,
})

export const FormGroupStyled = styled(FormGroup)({
  marginBottom: "16px",
  ".bp3-label": {
    display: "flex",
    alignItems: "center",
    color: SCIENT_COLORS.gray3,
    fontSize: "14px",
    marginBottom: "6px",

    svg: {
      color: SCIENT_COLORS.gray3,
    },
  },
})

export const InputContainer = styled(FlexContainer)({
  alignItems: "center",
  gap: "10px",
  width: "100%",
})

export const CurrencySwitchButton = styled(Button)({
  height: "30px",
  minWidth: "140px",
  background: SCIENT_COLORS.darkGray3,
  "&:hover": {
    background: SCIENT_COLORS.darkGray4,
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  ".bp3-icon": {
    marginRight: "6px",
    color: SCIENT_COLORS.blue4,
  },
})

export const FormContainer = styled.form({
  width: "100%",
})

export const FooterActions = styled(FlexContainer)({
  justifyContent: "flex-end",
  gap: "8px",
})

export const ReplaceButton = styled(Button)({
  background: SCIENT_COLORS.greenDefault,
  "&:hover": {
    background: SCIENT_COLORS.greenHover,
  },
  "&:disabled": {
    opacity: 0.6,
  },
  ".bp3-icon": {
    color: SCIENT_COLORS.lightGray1,
  },
})

export const FormSectionDivider = styled.div({
  borderTop: `1px solid ${SCIENT_COLORS.darkGray4}`,
  margin: "20px 0",
  width: "100%",
})

export const LimitPriceContainer = styled(FormGroupStyled)({
  marginTop: "12px",

  ".bp3-label": {
    svg: {
      color: SCIENT_COLORS.orange3,
    },
  },

  ".bp3-input": {
    height: "30px",
    background: SCIENT_COLORS.darkGray3,
    color: SCIENT_COLORS.lightGray1,
    border: `1px solid ${SCIENT_COLORS.darkGray5}`,
    boxShadow: "none",

    "&:focus": {
      boxShadow: `0 0 0 1px ${SCIENT_COLORS.blue3}`,
      border: `1px solid ${SCIENT_COLORS.blue3}`,
    },
  },
})

// Common styles for all input fields
const commonInputStyles = {
  height: "30px",
  background: SCIENT_COLORS.darkGray3,
  color: SCIENT_COLORS.lightGray1,
  border: `1px solid ${SCIENT_COLORS.darkGray5}`,
  boxShadow: "none",
  width: "100%",
  paddingLeft: "10px",

  "&:focus": {
    boxShadow: `0 0 0 1px ${SCIENT_COLORS.blue3}`,
    border: `1px solid ${SCIENT_COLORS.blue3}`,
  },
}

export const AmountInputWrapper = styled.div({
  flex: 1,
  width: "100%",
  input: {
    ...commonInputStyles,
  },
  ".bp3-input-group": {
    width: "100%",
  },
  ".bp3-numeric-input": {
    width: "100%",
  },
  // Style for dollar symbol in USD amount field
  ".input-prefix": {
    position: "absolute",
    left: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    color: SCIENT_COLORS.lightGray1,
    zIndex: 1,
  },
  // Adjust padding when prefix exists
  ".has-prefix input": {
    paddingLeft: "26px !important",
  },
})

export const LimitInputWrapper = styled.div({
  width: "100%",
  input: {
    ...commonInputStyles,
  },
})

export const SelectWrapper = styled.div({
  ".bp3-popover-target": {
    width: "100%",
  },

  ".bp3-button": {
    width: "100%",
    justifyContent: "space-between",
    textAlign: "left",
    background: SCIENT_COLORS.darkGray3,
    height: "30px",
    paddingLeft: "10px",

    "&:hover": {
      background: SCIENT_COLORS.darkGray4,
    },
  },
})
